module.exports = __webpack_public_path__ + "static/media/WaterfrontStation.8827142f.jpg";